import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, getURL } from '../../../app/api';
import Loader from '../../../UIComponents/Loader';

export default function UserInfo({ PopupID, userId, Header, Subheader, openKey }) {
    const store_data = JSON.parse(store());
    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState({});

    const fetchSingleData = async (edit_id) => {
        setLoading(true);
        try {
            const filter = { org_id: store_data?.org_id, id: edit_id };
            const response = await postAPI('/users/fetchSingle', { ...filter, user: store_data });
            const UsersData = response?.data?.length > 0 ? response?.data[0] : {};

            if (response?.status == 1) {
                setUserInfo({
                    id: UsersData['id'],
                    role: UsersData['role'],
                    name: UsersData['name'],
                    username: UsersData['username'],
                    email: UsersData['email'],
                    contact_number: UsersData['contact_number'],
                    image: UsersData['image'],
                    user_unique_id: UsersData['user_unique_id'],
                    createdAt: UsersData['createdAt'],
                    status: UsersData['account_status'],
                    is_block: UsersData['is_block'],
                });
            } else {
                setUserInfo({});
            }
        } catch (error) {
            setUserInfo({});
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userId) {
            fetchSingleData(userId);
        } else {
            setUserInfo({});
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [userId, openKey]);

    const isActive = Number(userInfo?.status) === 1 || userInfo?.status === true;
    const isBlocked = Number(userInfo?.is_block) === 1 || userInfo?.is_block === true;
    const avatarUrl = userInfo?.image ? `${getURL()}/${userInfo?.image}` : '';

    const getInitials = (name = '') => {
        const parts = name.trim().split(' ').filter(Boolean);
        if (!parts.length) return 'U';
        return parts.slice(0, 2).map(part => part[0]).join('').toUpperCase();
    };

    const formatDateTime = (value) => {
        if (!value) return 'Not available';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return 'Not available';
        return date.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const InfoItem = ({ label, value, icon, badge }) => (
        <div className="col-12 col-md-6">
            <div className="border rounded-4 p-3 h-100 bg-white shadow-sm">
                <div className="d-flex align-items-start gap-3">
                    <div
                        className={`rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 ${badge ? badge : 'bg-label-primary'}`}
                        style={{ width: 42, height: 42 }}
                    >
                        <i className={`fa ${icon || 'fa-circle-info'}`}></i>
                    </div>
                    <div className="min-w-0">
                        <div className="text-muted small mb-1">{label}</div>
                        <div className="fw-semibold text-dark text-break">{value || 'Not available'}</div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="modal fade" id={`${PopupID}`} tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
                    <div className="modal-body p-0">
                        <button
                            type="button"
                            className="btn-close position-absolute top-0 end-0 m-3 z-3"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>

                        {loading ? (
                            <div className="p-4 p-md-5">
                                <Loader />
                            </div>
                        ) : (
                            <div className="bg-light">
                                <div
                                    className="position-relative overflow-hidden"
                                    style={{
                                        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 55%, #334155 100%)',
                                    }}
                                >
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{
                                            background:
                                                'radial-gradient(circle at top left, rgba(255,255,255,0.16), transparent 35%), radial-gradient(circle at bottom right, rgba(59,130,246,0.18), transparent 32%)',
                                        }}
                                    />
                                    <div className="position-relative p-4 p-md-5 text-white">
                                        <div className="d-flex flex-column flex-md-row align-items-md-center gap-4">
                                            <div className="position-relative">
                                                <div
                                                    className="rounded-circle d-flex align-items-center justify-content-center overflow-hidden border border-4 border-white shadow"
                                                    style={{
                                                        width: 104,
                                                        height: 104,
                                                        background: 'rgba(255,255,255,0.12)',
                                                    }}
                                                >
                                                    {avatarUrl ? (
                                                        <img
                                                            src={avatarUrl}
                                                            alt={userInfo?.name || 'User avatar'}
                                                            className="w-100 h-100 object-fit-cover"
                                                        />
                                                    ) : (
                                                        <span className="fw-bold fs-3">
                                                            {getInitials(userInfo?.name)}
                                                        </span>
                                                    )}
                                                </div>
                                                <span
                                                    className={`position-absolute bottom-0 end-0 badge rounded-pill px-3 py-2 shadow-sm ${
                                                        isActive ? 'bg-success' : 'bg-secondary'
                                                    }`}
                                                    style={{ transform: 'translate(12%, 12%)' }}
                                                >
                                                    {isActive ? 'Active' : 'Inactive'}
                                                </span>
                                            </div>

                                            <div className="flex-grow-1">
                                                <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                                                    <h3 className="mb-0 text-white">
                                                        {`${Header ? `Users Info  - ${Header}` : userInfo?.name}`}
                                                    </h3>
                                                    {userInfo?.role && (
                                                        <span className="badge bg-label-light text-dark rounded-pill px-2 py-1">
                                                            {userInfo?.role}
                                                        </span>
                                                    )}
                                                    {isBlocked && (
                                                        <span className="badge bg-danger rounded-pill px-3 py-2">
                                                            Blocked
                                                        </span>
                                                    )}
                                                </div>
                                                {/* <p className="mb-2 text-white-50">
                                                    {Subheader || 'Detailed profile information for this user account.'}
                                                </p> */}
                                                <div className="d-flex flex-wrap gap-2">
                                                    <span className="badge bg-white text-dark rounded-pill px-3 py-2">
                                                        <i className="fa fa-id-card me-2"></i>
                                                        {userInfo?.user_unique_id || 'User ID unavailable'}
                                                    </span>
                                                    <span className="badge bg-white text-dark rounded-pill px-3 py-2">
                                                        <i className="fa fa-calendar me-2"></i>
                                                        {formatDateTime(userInfo?.createdAt)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-4 p-md-5">
                                    {userInfo?.username ? (
                                        <>
                                            <div className="row g-3 mb-4">
                                                <div className="col-12 col-md-4">
                                                    <div className="card border-0 shadow-sm rounded-4 h-100">
                                                        <div className="card-body">
                                                            <div className="text-muted small text-uppercase mb-1">Status</div>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className={`badge rounded-pill px-3 py-2 ${isActive ? 'bg-success' : 'bg-secondary'}`}>
                                                                    {isActive ? 'Active' : 'Inactive'}
                                                                </span>
                                                                <span className={`badge rounded-pill px-3 py-2 ${isBlocked ? 'bg-danger' : 'bg-label-success text-success'}`}>
                                                                    {isBlocked ? 'Blocked' : 'Not Blocked'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="card border-0 shadow-sm rounded-4 h-100">
                                                        <div className="card-body">
                                                            <div className="text-muted small text-uppercase mb-1">Role</div>
                                                            <div className="fw-bold fs-5 text-dark">{userInfo?.role || 'Not available'}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="card border-0 shadow-sm rounded-4 h-100">
                                                        <div className="card-body">
                                                            <div className="text-muted small text-uppercase mb-1">Member Since</div>
                                                            <div className="fw-bold fs-5 text-dark">{formatDateTime(userInfo?.createdAt)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card border-0 shadow-sm rounded-4 mb-4">
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                                        <h5 className="mb-0 text-dark">Profile Details</h5>
                                                        <span className="text-muted small">Account overview</span>
                                                    </div>

                                                    <div className="row g-3">
                                                        <InfoItem
                                                            label="Full Name"
                                                            value={userInfo?.name}
                                                            icon="fa-user"
                                                            badge="bg-label-primary"
                                                        />
                                                        <InfoItem
                                                            label="Username"
                                                            value={userInfo?.username || userInfo?.email}
                                                            icon="fa-at"
                                                            badge="bg-label-info"
                                                        />
                                                        <InfoItem
                                                            label="Email Address"
                                                            value={userInfo?.email}
                                                            icon="fa-envelope"
                                                            badge="bg-label-success"
                                                        />
                                                        <InfoItem
                                                            label="Contact Number"
                                                            value={userInfo?.contact_number}
                                                            icon="fa-phone"
                                                            badge="bg-label-warning"
                                                        />
                                                        <InfoItem
                                                            label="User Unique ID"
                                                            value={userInfo?.user_unique_id}
                                                            icon="fa-fingerprint"
                                                            badge="bg-label-danger"
                                                        />
                                                        <InfoItem
                                                            label="Created On"
                                                            value={formatDateTime(userInfo?.createdAt)}
                                                            icon="fa-clock"
                                                            badge="bg-label-secondary"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card border-0 shadow-sm rounded-4">
                                                <div className="card-body p-4">
                                                    <h5 className="mb-3 text-dark">Quick Summary</h5>
                                                    <div className="row g-3">
                                                        <div className="col-12 col-lg-6">
                                                            <div className="p-3 rounded-4 bg-label-primary">
                                                                <div className="text-muted small text-uppercase mb-1">Primary Email</div>
                                                                <div className="fw-semibold text-dark text-break">{userInfo?.email || 'Not available'}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6">
                                                            <div className="p-3 rounded-4 bg-label-info">
                                                                <div className="text-muted small text-uppercase mb-1">Access Level</div>
                                                                <div className="fw-semibold text-dark">{userInfo?.role || 'Not available'}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center py-5">
                                            <div className="mb-3">
                                                <i className="fa fa-user-circle fs-1 text-muted"></i>
                                            </div>
                                            <h5 className="mb-2">No user data found</h5>
                                            <p className="text-muted mb-0">We could not load any details for this user.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
